import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { DialogProps } from "@toolpad/core";
import { Close as CloseIcon } from "@mui/icons-material";
import { Flex } from "~/components/Flex";
import { NumberDot } from "~/components/guides/components";

interface GithubSecurityPipelineGetHelpDialogPayload {}

export const GithubSecurityPipelineGetHelpDialog = ({
  open,
  onClose,
}: DialogProps<GithubSecurityPipelineGetHelpDialogPayload>) => {
  const theme = useTheme();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={handleClose}
      slotProps={{ paper: { sx: { maxHeight: "568px" } } }}
    >
      <IconButton
        aria-label="close pairing"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 24,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h5"
        sx={{
          alignSelf: "stretch",
          textAlign: "center",
          color: "text.light",
          fontWeight: 700,
          textTransform: "uppercase",
          display: "flex",
          flexDirection: "column",
          p: 5,
          pb: 3,
        }}
      >
        How Security pipeline Works
        <Typography
          color="text.secondary"
          variant="body2"
          fontSize={16}
          sx={{ textTransform: "none" }}
        >
          Don’t just find problems, fix them. Powered by Ansible.
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, px: 5 }}>
        <Stack direction="column" gap={2}>
          <Flex alignItems="flex-start" gap={1}>
            <NumberDot
              number={1}
              backgroundColor={theme.palette.background.lightest}
            />
            <Typography>
              <b>Setup — </b>Follow the steps to setup Security pipeline in your
              Mondoo org to create a GitHub security repo, and install the app.
            </Typography>
          </Flex>
          <Flex alignItems="flex-start" gap={1}>
            <NumberDot
              number={2}
              backgroundColor={theme.palette.background.lightest}
            />
            <Typography>
              <b>Find — </b>In minutes, Security pipeline identifies fixable
              findings on your assets.
            </Typography>
          </Flex>

          <Flex alignItems="flex-start" gap={1}>
            <NumberDot
              number={3}
              backgroundColor={theme.palette.background.lightest}
            />
            <Typography>
              <b>Fix — </b>Security pipeline safley generates fixes that your
              team never has to write, saving hours of time.
            </Typography>
          </Flex>

          <Flex alignItems="flex-start" gap={1}>
            <NumberDot
              number={4}
              backgroundColor={theme.palette.background.lightest}
            />
            <Typography>
              <b>Ship — </b>Finally, it submit fixes as pull requests, for your
              team to review, merge, and deploy how and when it works for your
              team.
            </Typography>
          </Flex>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 5, pt: 0, gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          sx={{
            minWidth: "40px",
            height: "40px",
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
